// removed by extract-text-webpack-plugin
module.exports = {"pagination__button_prev":"_3r9gQnwq8ZdA-WUVAuwubg","pagination__button_next":"svlPw7OQ331mkuwffhP0F","pagination":"_1v0yc62asvcwD6AGfz_v-U","pagination_in-search-block":"_1sXpBuAorUdhLbIj93KZo1","pagination__item":"yY7jCdb7ur-6-4pV_767A","pagination__item_prev":"_2oTJc4aZnyy3EZn3Ae2gfQ","pagination__item_next":"_25Tsx__g6itmYzb0GCEaM9","pagination__button":"QuOBgr69KXH7qMiByqxhy","pagination__button_active":"_25KNwgo3FICHEf7FHjhztE","pagination__button-dots":"_1dMJTtdUBmG0_yLQ8i5ccY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PaginatorBlock/PaginatorBlock.module.scss
// module id = 793
// module chunks = 0